// src/components/SubmitTime/fields/InputTextField.tsx
// Modern React implementation of InputTextField custom field

import React, { useState, useEffect } from 'react';
import type { CustomFieldProps } from '../types';
import './InputTextField.css';

interface InputTextFieldProps extends CustomFieldProps {}

export const InputTextField: React.FC<InputTextFieldProps> = ({
  customField,
  canEdit,
  handleDynamicInputChange,
  UpdateCustomFields,
  showRequiredError,
}) =>
{
  const [value, setValue] = useState<string>(
    customField.Value === null || customField.Value === undefined ? '' : String(customField.Value),
  );

  // Update value when customField prop changes
  useEffect(() =>
  {
    const newValue =
      customField.Value === null || customField.Value === undefined
        ? ''
        : String(customField.Value);
    setValue(newValue);
  }, [customField.Value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    const newValue = event.target.value;
    setValue(newValue);
    handleDynamicInputChange(customField.CustomFieldId, newValue);
  };

  const handleBlur = () =>
  {
    if (UpdateCustomFields)
    {
      UpdateCustomFields(customField);
    }
  };

  return (
    <input
      className={`corgee-inpuSubmitTimet right${showRequiredError ? ' submit-required-error' : ''}`}
      disabled={!canEdit || !customField.ConversationIsEnable}
      type="text"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={customField.Placeholder}
      maxLength={customField.MaxLength}
    />
  );
};

export default InputTextField;
